import { colors } from '@constants/colors';
import { PreIPODealStatus, PreIPODealTypes } from '@constants/common';
import { hexToRgba } from '@utils/common';
import { translate } from '@utils/locale';

export const preIPODealsTableHeader = [
  {
    id: 'companyName',
    label: translate('preIpoDeals.tableHeader.companyName'),
    initialWidth: 200
  },
  {
    id: 'preIPOInternalName',
    label: 'Pre-IPO Internal Name',
    initialWidth: 220
  },
  {
    id: 'dealStatus',
    label: translate('preIpoDeals.tableHeader.dealStatus'),
    initialWidth: 200
  },
  {
    id: 'dealType',
    label: translate('preIpoDeals.tableHeader.dealType')
  },
  {
    id: 'startDate',
    label: translate('preIpoDeals.tableHeader.startDate'),
    initialWidth: 180
  },
  {
    id: 'endDate',
    label: translate('preIpoDeals.tableHeader.endDate'),
    initialWidth: 180
  },
  {
    id: 'noOfNewEnquiries',
    label: translate('preIpoDeals.tableHeader.noOfNewEnquiries'),
    initialWidth: 200,
    disableSort: true
  },
  {
    id: 'totalCommit',
    label: translate('preIpoDeals.tableHeader.totalCommit'),
    initialWidth: 200,
    disableSort: true
  },
  {
    id: 'totalInvested',
    label: translate('preIpoDeals.tableHeader.totalInvested'),
    initialWidth: 230,
    disableSort: true
  },
  {
    id: 'options',
    label: translate('preIpoDeals.tableHeader.actions'),
    disableSort: true
  }
];

export const preIPODealTypeColorMapping = {
  [PreIPODealTypes.WISHLIST]: {
    backgroundColor: hexToRgba(colors.seaSlateBlue, 0.1),
    textColor: colors.seaSlateBlue
  },
  [PreIPODealTypes.LIVE]: {
    backgroundColor: hexToRgba(colors.emeraldGreen, 0.15),
    textColor: colors.rainForestGreen
  },
  [PreIPODealTypes.COMING_SOON]: {
    backgroundColor: hexToRgba(colors.goldenOrange, 0.12),
    textColor: colors.deepOrange
  },
  [PreIPODealTypes.OTHER]: {
    backgroundColor: hexToRgba(colors.aquaBlue, 0.15),
    textColor: colors.indigoBlue
  }
};

export const preIPOStatusColorMapping = {
  [PreIPODealStatus.DRAFT]: {
    backgroundColor: colors.gray600,
    textColor: colors.gray600
  },
  [PreIPODealStatus.ACTIVE]: {
    backgroundColor: hexToRgba(colors.pastelGreen, 0.2),
    textColor: colors.salem
  },
  [PreIPODealStatus.EXPIRED]: {
    backgroundColor: hexToRgba(colors.coralRed, 0.15),
    textColor: colors.coralRed
  },
  [PreIPODealStatus.CLOSED]: {
    backgroundColor: colors.purple,
    textColor: colors.purple
  },
  [PreIPODealStatus.IN_REVIEW]: {
    backgroundColor: colors.primaryBlue,
    textColor: colors.primaryBlue
  }
};
